import { constants } from 'appConstants';
import { CUSTOMER_SERVICE_CONTACT_FRAGMENT } from 'components/ChatBV/constants';
import { formatText } from 'components/ChatBV/utils';

export const renderMessageContent = (text: string) => {
  const processedText = formatText(text || '');
  const lines = processedText.split('\n');

  if (text.toLowerCase().includes(CUSTOMER_SERVICE_CONTACT_FRAGMENT)) {
    return [
      <span key="customer-service-contact-1">
        We're here to help! You can reach the Beenverified support team through
        any of the options below:
      </span>,
      <br key="customer-service-contact-2" />,
      <br key="customer-service-contact-3" />,
      <span style={{ fontWeight: 'bold' }} key="customer-service-contact-4">
        📧 Contact Us Form
      </span>,
      <br key="customer-service-contact-5" />,
      <span key="customer-service-contact-6">
        Visit{' '}
        <a
          href="https://www.beenverified.com/contact/?src=chatbot"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.beenverified.com/contact
        </a>{' '}
        and choose "General Support" from the dropdown menu.
      </span>,
      <br key="customer-service-contact-7" />,
      <br key="customer-service-contact-8" />,
      <span style={{ fontWeight: 'bold' }} key="customer-service-contact-9">
        📧 Email Support
      </span>,
      <br key="customer-service-contact-10" />,
      <span key="customer-service-contact-11">
        For assistance, send an email to{' '}
        <a
          href="mailto:support@Beenverified.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          support@Beenverified.com
        </a>
        .
      </span>,
      <br key="customer-service-contact-12" />,
      <br key="customer-service-contact-13" />,
      <span style={{ fontWeight: 'bold' }} key="customer-service-contact-14">
        📞 Phone Support
      </span>,
      <br key="customer-service-contact-15" />,
      <span key="customer-service-contact-16">
        Call our toll-free number: 1 (844) 823-2869.
      </span>,
      <br key="customer-service-contact-17" />,
      <br key="customer-service-contact-18" />,
      <span style={{ fontWeight: 'bold' }} key="customer-service-contact-19">
        📬 Mailing Address
      </span>,
      <br key="customer-service-contact-20" />,
      <span key="customer-service-contact-21">MSC – 149098</span>,
      <br key="customer-service-contact-22" />,
      <span key="customer-service-contact-23">P.O. Box 105168</span>,
      <br key="customer-service-contact-24" />,
      <span key="customer-service-contact-25">Atlanta, GA 30348-5168</span>,
    ];
  }

  if (text.toUpperCase().includes('FCRA')) {
    return [
      <span key="fcra-compliance-1">{text}</span>,
      <br key="fcra-compliance-2" />,
      <span key="fcra-compliance-3">
        <a
          href={constants.links.fcraLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {constants.links.fcraLink}
        </a>
      </span>,
    ];
  }

  return lines.map((line, lineIndex) => {
    // Only process bold formatting if it exists in the line
    if (!line.includes('**')) {
      return (
        <span key={lineIndex}>
          {line}
          {lineIndex < lines.length - 1 && <br />}
        </span>
      );
    }

    const parts = line.split(/(\*\*[^*]+\*\*)/g);
    const parsedParts = parts.map((part, partIndex) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <b key={`${lineIndex}-${partIndex}`}>{part.slice(2, -2)}</b>;
      }
      return part;
    });

    return (
      <span key={lineIndex}>
        {parsedParts}
        {lineIndex < lines.length - 1 && <br />}
      </span>
    );
  });
};
